// @core/api/endpoints/notifications/list_contacts.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ListContactsResponse,
} from '../../../types/notifications';
import type { PaginatedRequest } from '../../../types/pagination';

const BASE_PATH = '/notifications';

/**
 * List contacts with filters
 * Returns a paginated list of contacts matching the specified filter criteria. Supports filtering by type, verification status, and associated entity.
 */
export async function ListContacts(
  params?: PaginatedRequest,
  options?: RequestOptions
): Promise<ListContactsResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/contacts`;
  const requestOptions = options;
  return client.get<ListContactsResponse>(requestPath, { ...requestOptions, params });
}
